module.exports = __webpack_public_path__ + "static/media/dwine.86d5fc95.svg";